(function ($) {
  if (!$ || !$.fn || !$.fn.zoom) return;

  const originalZoom = $.fn.zoom;
  const hasHoverPointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  function initializeZoom(target, options) {
    const image = target.querySelector('img[data-master-image]');
    const zoomUrl = options && options.url ? options.url : image && image.dataset.masterImage;

    if (!zoomUrl || target.homeaxZoomUrl === zoomUrl) return;

    if (target.homeaxZoomUrl) {
      $(target).trigger('zoom.destroy');
    }

    target.homeaxZoomUrl = zoomUrl;
    originalZoom.call($(target), Object.assign({}, options, { url: zoomUrl }));
  }

  $.fn.zoom = function (options) {
    return this.each(function () {
      const target = this;
      const productSlide = target.closest('.product-image-main .swiper-slide');

      if (!productSlide) {
        originalZoom.call($(target), options);
        return;
      }

      if (!hasHoverPointer.matches) return;

      if (productSlide.classList.contains('swiper-slide-active')) {
        initializeZoom(target, options);
        return;
      }

      if (target.homeaxZoomObserver) return;

      target.homeaxZoomObserver = new MutationObserver(() => {
        if (!productSlide.classList.contains('swiper-slide-active')) return;

        target.homeaxZoomObserver.disconnect();
        target.homeaxZoomObserver = null;
        initializeZoom(target, options);
      });

      target.homeaxZoomObserver.observe(productSlide, {
        attributes: true,
        attributeFilter: ['class']
      });
    });
  };
})(window.jQuery);
